import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { Tooltip } from '../base';
import {
    entityBadgeBaseStyles,
    entityBadgeHoverStyles,
    entityBadgeTokens,
    BADGE_ICON_SIZE,
    entityBadgeActionButtonHoverStyles,
} from './entity-badge.styles';

export const VisitLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    overflow: hidden;
    color: inherit;
    flex-grow: 1;
    min-width: 0;
    height: 100%;
    padding: 0 12px;
    text-decoration: none;
`;

export const VisitTooltip = styled(Tooltip)`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
`;

export const ActionSymbol = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: inherit;

    svg {
        width: ${BADGE_ICON_SIZE};
        height: ${BADGE_ICON_SIZE};
        fill: currentColor;
    }
`;

export const ActionIcon = styled(Icon)`
    width: ${BADGE_ICON_SIZE};
    height: ${BADGE_ICON_SIZE};
    fill: currentColor;
`;

export const ActionButton = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    border-left: 1px solid ${entityBadgeTokens.border};
    padding: 0 8px;
`;

export const ActionTooltip = styled(Tooltip)`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
`;

export const Badge = styled.div`
    ${entityBadgeBaseStyles}
    padding: 0;
    overflow: hidden;

    ${entityBadgeHoverStyles}

    &:hover {
        ${ActionButton} {
            ${entityBadgeActionButtonHoverStyles}
        }
    }
`;
